import type { NotificationRenderer } from "./types";
import { StatusTransitionWidget } from "../StatusTransitionWidget";
import { NotificationMetadataCard } from "../NotificationMetadataCard";
import { BodyCard } from "./BodyCard";

export const AuditStatusChangeRenderer: NotificationRenderer = {
  render: (notification) => {
    const { previousStatus, newStatus, changedBy, ...rest } =
      notification.metadata ?? {};

    const filteredMeta = Object.fromEntries(
      Object.entries(rest).filter(
        ([k]) => !["previousStatus", "newStatus", "changedBy"].includes(k),
      ),
    );

    return (
      <>
        {previousStatus && newStatus && (
          <StatusTransitionWidget
            from={previousStatus}
            to={newStatus}
            changedBy={changedBy}
          />
        )}
        <BodyCard body={notification.body} delay={0.15} />
        {Object.keys(filteredMeta).length > 0 && (
          <NotificationMetadataCard metadata={filteredMeta} />
        )}
      </>
    );
  },
};
